import { render, staticRenderFns } from "./ComplaintResolutionProductivity.vue?vue&type=template&id=50fcadc3"
import script from "./ComplaintResolutionProductivity.vue?vue&type=script&lang=js"
export * from "./ComplaintResolutionProductivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports